import { useEffect, useState } from "react";
import api from "@/lib/api";
import { BadgeCheck, Check, X, Share2 } from "lucide-react";
import VerifiedShareModal from "@/components/VerifiedShareModal";

// CRASH READY VERIFIED — component-by-component status card for the client,
// with public share link, QR code and printable one-pager (never personal data).
export default function CrashReadyVerifiedCard({ caseId }) {
  const [v, setV] = useState(null);
  const [showShare, setShowShare] = useState(false);

  useEffect(() => {
    if (!caseId) return;
    api.get(`/cases/${caseId}/verification`).then(({ data }) => setV(data)).catch(() => {});
  }, [caseId]);

  const crv = v?.crash_ready_verified;
  if (!crv || v.legacy) return null;
  const doneCount = crv.components.filter((c) => c.done).length;
  if (doneCount === 0) return null;

  return (
    <div className="mt-6 rounded-3xl border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] overflow-hidden" data-testid="crash-ready-verified-card">
      <div className={`p-5 flex items-center gap-3 ${crv.achieved ? "bg-emerald-600 text-white" : "bg-white border-b border-slate-100"}`}>
        <BadgeCheck className={`w-7 h-7 ${crv.achieved ? "text-white" : "text-slate-300"}`} />
        <div className="flex-1">
          <div className={`font-heading font-extrabold tracking-wide ${crv.achieved ? "text-white" : "text-navy"}`} data-testid="crv-status">
            {crv.achieved ? "CRASH READY VERIFIED" : `Verification progress — ${doneCount}/${crv.components.length}`}
          </div>
          <div className={`text-xs ${crv.achieved ? "text-emerald-100" : "text-slate-500"}`}>Each component below is verified individually.</div>
        </div>
        <button onClick={() => setShowShare(true)} data-testid="crv-share-btn" title="Share, print or show a QR of this verification checklist"
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-all ${crv.achieved ? "bg-white/15 text-white hover:bg-white/25" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>
          <Share2 className="w-3.5 h-3.5" /> Share
        </button>
      </div>
      <div className="bg-white p-5 grid sm:grid-cols-2 gap-1.5" data-testid="crv-components">
        {crv.components.map((c) => (
          <div key={c.key} className="flex items-center gap-2 text-sm">
            {c.done ? <Check className="w-4 h-4 text-emerald-600 shrink-0" /> : <X className="w-4 h-4 text-slate-300 shrink-0" />}
            <span className={c.done ? "text-navy" : "text-slate-400"}>{c.label}</span>
          </div>
        ))}
      </div>
      <div className="bg-slate-50 px-5 py-3 text-[11px] text-slate-400">{crv.disclaimer}</div>
      {showShare && <VerifiedShareModal caseId={caseId} verification={v} onClose={() => setShowShare(false)} />}
    </div>
  );
}
